import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
// Image imports commented out - using initials instead
// import Img1 from '../../images/testimonial/1.jpg'
// import Img2 from '../../images/testimonial/2.jpg'
// import Img3 from '../../images/testimonial/3.jpg'
import SectionTitle from '../SectionTitle/SectionTitle';


const testimonials = [
    {
        id: '01',
        initials: 'MT',
        bgColor: '#4A90E2',
        Des: "After years of chronic knee pain from arthritis, the stem cell treatment at Amped Therapeutics gave me my life back. I'm now able to enjoy Florida's beautiful beaches and golf courses pain-free. The procedure was safe, professional, and the results exceeded my expectations.",
        title: 'Margaret Thompson',
        sub: "Knee Arthritis Patient - Sarasota",
    },
    {
        id: '02',
        initials: 'RM',
        bgColor: '#00ACC1',
        Des: "As a former athlete dealing with shoulder injuries, I was skeptical about stem cell therapy. The medical team's expertise and the center's advanced technology convinced me. Six months later, I'm back to swimming and playing tennis without pain. Truly life-changing!",
        title: 'Robert Martinez',
        sub: "Rotator Cuff Injury - Fort Myers",
    },
    {
        id: '03',
        initials: 'PW',
        bgColor: '#26A69A',
        Des: "The neuropathy in my feet was unbearable until I found Amped Therapeutics. Their innovative approach to regenerative medicine is remarkable. The stem cell treatment has reduced my pain by 80% and I can finally sleep through the night again.",
        title: 'Patricia Williams',
        sub: "Neuropathy Patient - Naples",
    },


]




const Testimonial = (props) => {

    return (

        <section className={"" + props.tClass} style={{paddingTop: '60px'}}>
            <div className="container">
                <div className="row justify-content-left">
                    <div className="col-12" style={{marginBottom: '40px'}}>
                        <SectionTitle title='Patient Success Stories' subtitle="Real Results from Amped Therapeutics Patients" />
                    </div>
                </div>
                <div className="row testimonial_slider" style={{marginTop: '20px'}}>
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={30}
                        slidesPerView={2}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        loop={true}
                        speed={300}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination',
                        }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                pagination: {
                                    enabled: true,
                                },
                            },
                            992: {
                                slidesPerView: 2,
                                pagination: {
                                    enabled: false,
                                },
                            },
                        }}
                    >
                        {testimonials.map((testitem, titem) => (
                            <SwiperSlide key={titem}>
                                <div className="testimonial_card">
                                    <ul>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                    </ul>
                                    <p>{testitem.Des}</p>
                                    <div className="ath">
                                        <div className="image">
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '50%',
                                                backgroundColor: testitem.bgColor,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontSize: '20px',
                                                fontWeight: 'bold'
                                            }}>
                                                {testitem.initials}
                                            </div>
                                        </div>
                                        <div className="text">
                                            <h3>{testitem.title}</h3>
                                            <span>{testitem.sub}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="swiper-pagination"></div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;







